<app-base-modal modalName="driver_licence_info_modal"
                [inProcessModal]="false"
                [customCloseAction]="closeCalcModal.bind(this)"
                [hideClose]="false">
    <ng-template>
        <div class="driver-licence-container">
            <img class="licence-sample" 
                src="./assets/images/reskins/licence-sample.svg" 
                alt="licence-sample"/>
            <div class="driver-licence-wrapper">
                <div class="driver-licence-title"> 
                    {{ s.detailsUnmatchedTitle }}
                </div>
                <div class="driver-licence-info">
                    {{ s.detailsUnmatchedInfo }}
                </div>
            </div>
        </div>
    </ng-template>
</app-base-modal>